import styled from "styled-components";
import { QRCodeSVG } from "qrcode.react";

type QRCodeProps =
  | {
      src: string;
      value?: never;
      size?: number;
    }
  | {
      value: string;
      src?: never;
      size?: number;
    };

const DEFAULT_QR_CODE_SIZE = 100;

const QRCode = (props: QRCodeProps) => {
  const size = props.size ?? DEFAULT_QR_CODE_SIZE;

  return (
    <QRCodeContainer $size={size}>
      {props.value !== undefined ? (
        <QRCodeVector value={props.value} size={size} level="M" $size={size} />
        // <QRCodeVector value={"D414AC912A9F1BE0010A564"} size={size} level="M" $size={size} />
      ) : (
        <QRCodeImage src={props.src} $size={size} />
      )}
    </QRCodeContainer>
  );
};

export default QRCode;

const QRCodeContainer = styled.div<{ $size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.$size}px;
  width: ${(props) => props.$size}px;
`;

const QRCodeVector = styled(QRCodeSVG)<{ $size: number }>`
  height: ${(props) => props.$size}px;
  width: ${(props) => props.$size}px;
`;

const QRCodeImage = styled.div<{ src: string; $size: number }>`
  background: center no-repeat ${(props) => `url(${props.src})`};
  /* height: min(40vw, 160px); */
  /* width: min(40vw, 160px); */
  height: ${(props) => props.$size}px;
  width: ${(props) => props.$size}px;
  background-size: 140%;
`;
